// Fail-closed resolver for the PostHog client/server init config. See MAR-662:
// a missing public env var can bake into the bundle as the literal string
// "undefined" (truthy), which defeats naive `key && ...` / `host || fallback`
// guards and points PostHog at /undefined/array/undefined/config.js. This
// treats "", "undefined", and "null" (any case, trimmed) as missing.

export const DEFAULT_POSTHOG_HOST = "https://us.i.posthog.com"

const MISSING_ENV_VALUES = new Set(["", "undefined", "null"])

export type PostHogConfig = {
  key: string
  apiHost: string
}

export function resolvePostHogConfig(
  rawKey: string | undefined | null,
  rawHost: string | undefined | null,
): PostHogConfig | null {
  const key = normalizePostHogEnv(rawKey)
  if (!key) {
    return null
  }

  return {
    key,
    apiHost: normalizePostHogEnv(rawHost) ?? DEFAULT_POSTHOG_HOST,
  }
}

function normalizePostHogEnv(
  raw: string | undefined | null,
): string | undefined {
  if (raw == null) {
    return undefined
  }

  const trimmed = raw.trim()
  return MISSING_ENV_VALUES.has(trimmed.toLowerCase()) ? undefined : trimmed
}
